<template>
  <b-modal
    centered
    :hide-header="true"
    :hide-footer="true"
    @hide="hidden"
    body-class="m-5"
    :visible="isShown"
    :id="id"
  >
    <template v-slot:default>
      <GenericForm
        :title="title"
        :action="action"
        :actionId="actionId"
        :canSubmit="canSubmit"
        :cancelable="cancelable"
        :otherValues="otherValues"
        :showButtons="showButtons"
        :id="id + '-form'"
        @submited="submited"
        @canceled="canceled"
      >
        <slot />
      </GenericForm>
    </template>
  </b-modal>
</template>

<script>
import GenericForm from "./GenericForm.vue";
/**
 * @description Composant générique pour les formulaires utilisant des « modals »
 * @author Alexandre Gallant
 * @vue-prop {String} title - Titre du formulaire
 * @vue-prop {Function} action - Méthode à appeler « onSubmit »
 * @vue-prop {Function} canSubmit - Méthode à appeler pour savoir si le contenu des contrôles est valide
 * @vue-prop {Boolean} cancelable - Si le formulaire doit inclure un bouton « annuler »
 * @vue-prop {Number} actionId - Id à donner au GenericForm quand on veut utiliser un article existant pour la requête
 * @vue-prop {Boolean} isShown - Si le modal doit être affiché
 * @vue-prop {Object} otherValues - Valeurs qui doivent être envoyées dans la requête et qui ne sont pas dans le formulaire
 * @vue-prop {Boolean} showButtons - Si l'on doit afficher les boutons
 * @vue-prop {String} id - Id à donner au modal
 * @vue-event {Object} submited - Émet le résultat du submit
 * @vue-event {void} canceled - Émet que le formulaire a été annulé
 */
export default {
  name: "GenericFormModal",
  components: {
    GenericForm
  },
  props: {
    title: {
      type: String,
      required: false
    },
    action: {
      type: Function,
      required: true
    },
    canSubmit: {
      type: Function,
      required: true
    },
    cancelable: {
      type: Boolean,
      default: true
    },
    actionId: {
      type: Number,
      required: false
    },
    isShown: {
      type: Boolean,
      required: true
    },
    otherValues: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    showButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    /**
     * @description Gère l'évènement « submited » du formulaire
     * @param {Object} result Le résultat du submit
     */
    submited(result) {
      this.$emit("submited", result);
    },
    /**
     * @description Gère l'évènement « canceled » du formulaire
     */
    canceled() {
      this.$emit("canceled");
    },
    /**
     * @description Gère l'événement « hide » du modal
     * @param {Object} trigger La cause de l'événement
     */
    hidden(trigger) {
      if (trigger.trigger == "backdrop" || trigger.trigger == "esc") {
        this.canceled();
      }
    }
  }
};
</script>
